import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardBody, Container, Row, Col, Button, CardHeader, InputGroup, InputGroupAddon, InputGroupText, Input, ButtonGroup, Label, Nav, NavLink } from 'reactstrap';
import { useCaptureResults } from '../../../hooks/captureResults/useCaptureResults';
import { ViewExam } from './ViewExam';
import { useHistory } from 'react-router-dom';
import { ModalPreViewMedicalOrder } from '../../../components/ResultsCapture/ModalPreViewMedicalOrder';
import { ModalViewMedicalOrder } from '../../../components/ResultsCapture/ModalViewMedicalOrder';
import './styleCaptureResults.css';
import { ButtonValidate } from './ButtonValidate';
import { ModalConfirmReleaseAll } from '../../../components/ResultsCapture/ModalConfirmReleaseAll';
import { ModalViewDocImagenology } from '../../../components/ResultsCapture/ModalViewDocImagenology';
import '../../../assets/css/cardFloting.css';
import { cedimi, labcen, demo, semlab, pyrsa } from '../../../constant/globalConstantsTypeClients'
import { ConfigServer } from '../../../data/config'
import { ModalPrintI } from '../../../components/dashboard/default/ModalPrintI';
import { ModalTableGlobalComment } from '../../../components/ResultsCapture/ModalTableGlobalComment'
import { SidebarClinicalInfo } from './SidebarClinicalInfo';
import { ModalExamsEmail } from '../../../components/dashboard/default/ModalExamsEmail';

export const CaptureResultsFromNim = () => {
    const txtsection = localStorage.getItem('TextAS');
    const [cabecera, setCabecera] = useState(true);
    const {

        loading, view,
        loadingButton, analytes, profiles, sections, patient, listDoctors, sendDoctor, saveIndividualAnalyte, saveAllAnalytes, releaseExam, releaseAll, validateAnalyte, validateExam, validateProfile, printAvailable, dobleValidacion, resultsPartial, printWorkOrder, sendResultForEmail,
        observations, commentsPrintResult, handleEditCommentsPrintResults, saveCommentsWorkOrder,
        microBacteriums, addMicroAislado, microAntibiograms,
        nimPatient, commentsFlebo, workMedicalOrder, workMedicalOrderPDF, workMedicalOrderPDFLoading, workMedicalOrderPDFDownload, type_file,
        handleCreate, closeDialog, toggle, method, modal, modalTitle1, typeModal, modalRelease, toggleRelease, loadingRelease, getViewPreview, previewWorkOrder,
        saveIndividualExamImagenology, handleGetDocumentImagenology, modalViewImagenology, modalTitleImg, toggleModalViewImagenology, documentImagenology, loadingPatient,
        removeValidationFromExamOrProfile, updateMethod, paid, credit_payment, setAnalytes,
        backNim, nextNim, gotoNim, typeModalMedical, toggleMedical, modalMedical,
        // * BACTERIUMS
        microAntibiotics, setMicroAntibiotics, setMicroBacteriums, handleTypeBacterium, handleChangeComments, removeBacterium1, removeBacteriumAntibitic,
        ValidateBacterium, UnValidateBacterium, ReleaseBacterium, UnReleaseBacterium,

        // * PRESUMPTIVE
        addPresumptiveResult, presumptive, setPresumptive, removePresumptiveResult, handleChangePresumptive, PrintingPresumptiveResult, cancelRemovePresumtiveResults, printingGlobal, cancelPrintingPresumptive, removePrintingGlobal,

        // * VALIDATIONS PRESUMTIVE RESULTS
        valdatePresumtiveResults, ReleasePresumtiveResults, unvalidatePresumtiveResults, unreleasePresumtiveResults,

        // * CONFIGURATION MENU
        executeScroll,

        // * COMMENTS GLOBAL
        handleChangeIsolated, microComments, addCommentGlobal, handleChangeResult, handleTypeResult,
        handleCreateGlobalComment, modalCrudComment, toggleCrudComment, modalTableGlobalComment, toggleTableGlobalComment,
        saveCreate, handleInputChange, text, type, comments, handleDeleteCommentText, search, setSearch,
        keyComments,

        //* Refresh work order exam
        handleRefresh,

        // *PDF letterhead
        historicMode, printHistoricPdf, pdf_historic, pdf_without_letter,

        // ? CONFIGURATION QUESTION SAMPLING
        dataQuestionSampling,

        //*BITACORA
        microBinnacleCedimi, printBitacoraMedica, workOrderId,
        handleInsert,

        //* List exam print 
        handleListPrint, letter, togglePrintI, typeModalPrintI, modalPrintI, dataExams, handleCheckProfile, handleCheckAll, Impresionbyexam, id_workorder_print, handleCheckAllProfile,
        //* TABLE clinical Infromation
        uniqueQuestions, tableRows,

        //* CURVES
        listCurves, handleChangeCurveResult, handleChangeCurveTime, disabledInputFollowUp, handleResetResultCurves,

        company,

        //*
        loadingValidate, loadingReleaseExam, loadingRemove,
        changeMethodCurves, fetchExamMethodData, setListCurves, disableMethodInput, appCodeOrMethodExam, setAppCodeOrMethodExam,
        loadingValidateProfile,
        loadingReleaseExamCapture, loadingRemoveCapture, loadingValidateCapture, loadingValidateProfileC,
        idWChart, codeAgreement,
        countSample, validCount, allValidated,

        canPreview, loadingPdf, openDialogRelease, closeDialogRelease,

        //* DIALOG PRINT AND SEND
        handleListExamEmail, toggleListExamEmail, modalExamsEmail,
        handleFindExam, sendResultEmail, setStep, sendConfig, handleSendEmail,
        sending,
        setAuditPanel, auditPanel, markAllActive, handleMarkAllClick, step,
        isSelectable, statusMap, toggleAuditPanel, toggleProfile, openProfiles, selectedCount, resetModalExamEmail,
        getFullAuditHistory, modalAlert, showDeleteAlert, loadingExport, handleClear, handleSearch,
        saveDeleteComment, closeDeleteAlertText, openDeleteAlertText, setIdDelete, handleExportExcelComment,
        searchComment, closeDialogComments, handleFullUnvalidate, getStatus, _url_helen,

        getResultsHistory, selectedExam, visibleSidebar, historicoRaw, historicoData, setSelectedExam, setVisibleSidebar, setHistoricoRaw,
        setHistoricoData, handleHistorico, getUltimos3Nims, buildHistorico3, setLoadingHistorico, loadingHistorico, getNimsData,
        hasHistorico, historicoGlobal,
        _capture_lock,

        //? PATIENT HISTORY
        showResistanceView, setShowResistanceView

    } = useCaptureResults();
    console.log("🚀 ~ CaptureResultsFromNim ~ countSample:", countSample)
    // console.log("🚀 ~ CaptureResultsFromNim ~ company:", company)
    // console.log("🚀 ~ CaptureResultsFromNim ~ countSample:", countSample)
    console.log("CAMBIOS EN EL REFRESH DE LA CAPTURA");
    console.log("SEGUNDA PRUEBA DE CAMBIOS");

    let _url = localStorage.getItem('url_helen');
    let enable_tracking_toma = localStorage.getItem('enable_tracking_toma');
    let _menu = localStorage.getItem('menu');
    console.log("🚀 ~ CaptureResultsFromNim ~ _menu:", _menu)



    const [validMicro, setValidMicro] = useState(false)


    const [visibleTop, setVisibleTop] = useState(false);

    const [showStickyPatient, setShowStickyPatient] = useState(false);

    const [isSidebarOpen, setIsSidebarOpen] = useState(
        localStorage.getItem("sidebartoggle") === "true"
    );

    const [isHorizontalMenu, setIsHorizontalMenu] = useState(
        localStorage.getItem("menu") === "true"
    );
    useEffect(() => {

        const handleScroll = () => {

            const patientCard = document.getElementById("patientGeneralContainer");

            if (patientCard) {

                const rect = patientCard.getBoundingClientRect();

                const isHidden = rect.bottom <= 80;

                setShowStickyPatient(prev => {
                    if (prev !== isHidden) {
                        return isHidden;
                    }

                    return prev;
                });
            }
        };

        window.addEventListener("scroll", handleScroll);

        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };

    }, []);

    useEffect(() => {

        const checkSidebar = () => {

            const value = localStorage.getItem("sidebartoggle")?.toLowerCase() === "true";

            setIsSidebarOpen(value);
        };

        const interval = setInterval(checkSidebar, 150);

        return () => clearInterval(interval);

    }, []);


    useEffect(() => {

        const checkMenu = () => {

            const value = localStorage.getItem("menu")?.toLowerCase() === "true"
            setIsHorizontalMenu(value);
        };

        const interval = setInterval(checkMenu, 150);

        return () => clearInterval(interval);

    }, []);

    return (
        <Fragment>
            <Container fluid={true} className='position-relative pb-3' >
                {

                    loadingPatient === true && !showStickyPatient ?

                        <div className="customizer-links" style={{ width: "45px" }} >
                            <Nav className="captureResultsNav">

                                <NavLink
                                    className="captureNavBtn"
                                    onClick={() => executeScroll()}
                                    style={{cursor: 'pointer'}}
                                >
                                    <div className="settings">
                                        <i className="icofont icofont-arrow-up f-18 text-warning" style={{cursor: 'pointer'}}></i>
                                    </div>

                                    <span>Ir arriba</span>
                                </NavLink>


                                <NavLink
                                    className={`captureNavBtn ${loadingButton || nextNim == null ? "disabled" : ""
                                        }`}
                                    onClick={() =>
                                        !loadingButton &&
                                        nextNim != null &&
                                        gotoNim(nextNim)
                                    }
                                    style={{
                                        cursor:
                                            loadingButton || nextNim == null
                                                ? "not-allowed"
                                                : "pointer",
                                        opacity:
                                            loadingButton || nextNim == null
                                                ? 0.6
                                                : 1
                                    }}
                                >
                                    <div className="settings">
                                        <i className="icofont icofont-arrow-left f-18 text-success" style={{cursor: 'pointer'}}></i>
                                    </div>

                                    <span>Anterior</span>
                                </NavLink>


                                <NavLink
                                    className={`captureNavBtn ${loadingButton || backNim == null ? "disabled" : ""
                                        }`}
                                    onClick={() =>
                                        !loadingButton &&
                                        backNim != null &&
                                        gotoNim(backNim)
                                    }
                                    style={{
                                        cursor:
                                            loadingButton || backNim == null
                                                ? "not-allowed"
                                                : "pointer",
                                        opacity:
                                            loadingButton || backNim == null
                                                ? 0.6
                                                : 1
                                    }}
                                >
                                    <div className="settings">
                                        <i className="icofont icofont-arrow-right f-18 text-danger" style={{cursor: 'pointer'}}></i>
                                    </div>

                                    <span>Siguiente</span>
                                </NavLink>


                                <NavLink
                                    className="captureNavBtn"
                                    onClick={saveAllAnalytes}
                                    style={{
                                        cursor: loadingButton ? "not-allowed" : "pointer",
                                        opacity: loadingButton ? 0.7 : 1
                                    }}
                                >
                                    <div className="settings">
                                        {
                                            loadingButton
                                                ? <i className="fa fa-spinner fa-spin f-18"></i>
                                                : <i className="icofont icofont-diskette f-18 text-primary" style={{cursor: 'pointer'}}></i>
                                        }
                                    </div>

                                    <span>
                                        {
                                            loadingButton
                                                ? "Guardando..."
                                                : "Guardar"
                                        }
                                    </span>
                                </NavLink>


                                <NavLink
                                    className="captureNavBtn"
                                    onClick={() => getViewPreview(true)}
                                    style={{cursor: 'pointer'}}
                                >
                                    <div className="settings">
                                        <i className="icofont icofont-document-search f-18" style={{ color: '#04b0ff', cursor: 'pointer'}}></i>
                                    </div>

                                    <span>Vista previa</span>
                                </NavLink>



                                {
                                    enable_tracking_toma &&
                                    <NavLink
                                        className="captureNavBtn"
                                        onClick={() => setVisibleTop(true)}
                                        style={{cursor: 'pointer'}}
                                    >
                                        <div className="settings">
                                            <i className="icofont icofont-doctor-alt f-18" style={{ color: '#ff7504', cursor: 'pointer' }}></i>
                                        </div>

                                        <span>Información clínica</span>
                                    </NavLink>
                                }


                                <NavLink
                                    className="captureNavBtn"
                                    onClick={() =>
                                        window.location.href = `/busqueda/trabajo-dia`
                                    }
                                    style={{cursor: 'pointer'}}
                                >
                                    <div className="settings">
                                        <i className="icofont icofont-undo f-18" style={{ color: '#030303', cursor: 'pointer' }}></i>
                                    </div>

                                    <span>Regresar</span>
                                </NavLink>

                            </Nav>
                        </div>
                        // <Card className='floating-card p-1'>
                        //     <ButtonGroup
                        //         vertical
                        //     >
                        //         <Button
                        //             block={true}
                        //             size="sm"
                        //             onClick={() => executeScroll()}
                        //             outline color='warning'
                        //         >
                        //             <i className="icofont icofont-arrow-up f-20"></i>
                        //         </Button>
                        //         <Button
                        //             block={true}
                        //             size="sm"
                        //             onClick={() => gotoNim(nextNim)}
                        //             outline color='success'
                        //             disabled={loadingButton || nextNim == null}
                        //             className={loadingButton ? "disabled progress-bar-animated progress-bar-striped" : ""}
                        //         >
                        //             <i className="icofont icofont-arrow-left f-20"></i>
                        //         </Button>
                        //         <Button
                        //             block={true}
                        //             size="sm"
                        //             onClick={() => gotoNim(backNim)}
                        //             outline color='danger'
                        //             disabled={loadingButton || backNim == null}
                        //             className={loadingButton ? "disabled progress-bar-animated progress-bar-striped" : ""}
                        //         >
                        //             <i className="icofont icofont-arrow-right f-20"></i>
                        //         </Button>

                        //         <Button
                        //             block={true}
                        //             size="sm  "
                        //             onClick={saveAllAnalytes}
                        //             outline color='info'
                        //             disabled={loadingButton}
                        //             className={loadingButton ? "disabled progress-bar-animated progress-bar-striped" : ""}
                        //         >
                        //             <i className="icofont icofont-diskette f-20"></i>
                        //         </Button>
                        //         <Button
                        //             block={true}
                        //             size="sm "
                        //             onClick={() => getViewPreview(true)}
                        //             outline color='primary'
                        //         >
                        //             <i className="icofont icofont-document-search f-20"></i>
                        //         </Button>

                        //         <Button
                        //             block={true}
                        //             size="sm "
                        //             onClick={() => setVisibleTop(true)}
                        //             outline color='danger'
                        //             className={enable_tracking_toma ? "" : "d-none"}
                        //         >

                        //             <i className="icofont icofont-doctor-alt f-20 text-danger"></i>
                        //         </Button>

                        //         <Button
                        //             block={true}
                        //             size="sm "
                        //             outline color='dark'
                        //             onClick={() => window.location.href = `/busqueda/trabajo-dia`}
                        //         >
                        //             <i className="icofont icofont-undo f-16"></i>
                        //         </Button>
                        //     </ButtonGroup>
                        // </Card>
                        :
                        ""
                }
                <div className='container-global-zoom'>
                    <Col sm="12" className='p-l-0 p-r-0' >
                        {
                            loadingPatient === false ? (
                                <Col md="12" className='text-center p-l-0 p-r-0'>
                                    <Card className='shadow' style={{ height: "380px" }}>
                                        <Row className='mt-2'> <br />
                                            <Col xs="12" sm="12" md="12" lg="12" xl="12" className='text-center'>  <br /> <br /> <br /> <br />
                                                <img src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")} className='animate__animated animate__pulse animate__infinite ' style={{ width: '130px' }} />
                                            </Col>
                                        </Row>
                                        <Row className='mt-2'>
                                            <Col sm="3" md="3" lg="3" className='text-center'></Col>
                                            <Col sm="2" md="2" lg="2" className='text-left p-r-0'>
                                                <p className='f-18 text-primary animate__animated animate__pulse animate__infinite'> <b>Cargando</b></p> <br />

                                            </Col>
                                            <Col sm="1" md="1" lg="1" className='text-center'>
                                                <br />
                                                <p className='animate__animated animate__fadeInDown animate__infinite text-info'><i className="fa fa-circle f-14"></i></p>
                                            </Col>
                                            <Col sm="1" md="1" lg="1" className='text-center'>
                                                <br />
                                                <p className='animate__animated animate__fadeInDown animate__slow animate__infinite text-primary'><i className="fa fa-circle f-14"></i></p>
                                            </Col>
                                            <Col sm="1" md="1" lg="1" className='text-center'>
                                                <br />
                                                <p className='animate__animated animate__fadeInDown animate__slower animate__infinite text-info'><i className="fa fa-circle f-14"></i></p>
                                            </Col>
                                            <Col sm="2" md="2" lg="2" className='text-center'></Col>
                                        </Row>

                                    </Card>
                                </Col>
                            ) : (
                                nimPatient && nimPatient.length > 0 ? (
                                    <>
                                        <Card className=' height-equal pricingtable pt-0 pb-0 pr-0 pl-0 mb-3'>
                                            <Row className="m-0" id="patientGeneralContainer">
                                                <Col sm="4" className="p-2" >
                                                    <div className="header-capture">

                                                        <div className="header-capture-left">
                                                            <i className="fa fa-user-circle header-capture-icon"></i>

                                                            <span className="header-capture-title">
                                                                Datos del paciente
                                                            </span>
                                                        </div>

                                                    </div>

                                                    <Row>
                                                        <Col xs="3" sm="3" md="3" lg="3" xl="3" className='p-l-1 p-r-1 text-center'> <br />
                                                            {
                                                                (patient.name_gender) === "MASCULINO" ?
                                                                    <div className="profile-vector"><img className="imgGender" src={require("../../../assets/images/user/hombre.png")} style={{ width: "80%" }} alt="" /></div>
                                                                    :
                                                                    <div className="profile-vector"><img className="imgGender" src={require("../../../assets/images/user/mujer.png")} style={{ width: "80%" }} alt="" /></div>
                                                            }
                                                        </Col>

                                                        <Col xs="9" sm="9" md="9" lg="9" xl="9" className='p-l-0 text-left pt-3' style={{ fontSize: '11px' }}>
                                                            <Col xs={12} className="capture-card pb-2">
                                                                <i className="pi pi-user"></i>

                                                                <label className='capture-name'>
                                                                    {patient.name} {patient.paternal_surname} {patient.maternal_surname}
                                                                </label>
                                                            </Col>
                                                            <div className="capture-chip-row">

                                                                <div className="capture-chip">
                                                                    {nimPatient}
                                                                </div>

                                                                <div className="capture-chip">
                                                                    <i className='fa fa-birthday-cake'></i>&nbsp;
                                                                    {patient.age > 0
                                                                        ? patient.age + " año(s)"
                                                                        : patient.format_age}
                                                                </div>

                                                                <div className="capture-chip">
                                                                    <i className='fa fa-venus-mars' ></i>&nbsp;
                                                                    {patient.name_gender}
                                                                </div>

                                                            </div>

                                                            <Col xs={12} className="capture-card pt-3">
                                                                <i className="fa fa-envelope"></i>

                                                                <label className='pPatient pt-1'>
                                                                    {patient.email === ""
                                                                        ? "Sin correo registrado"
                                                                        : patient.email}
                                                                </label>
                                                            </Col>

                                                            <Col xs={12} className="capture-card pt-1">
                                                                <i className="fa fa-phone"></i>

                                                                <label className='pPatient'>
                                                                    {patient.phone === ""
                                                                        ? "Sin registro telefónico"
                                                                        : patient.phone}
                                                                </label>
                                                            </Col>




                                                        </Col>
                                                    </Row>



                                                    {/* PENDING*/}
                                                    <Col xs="12" className={(enable_tracking_toma === "True" || _url === pyrsa) ? "pb-0" : "d-none"}    >

                                                        <div
                                                            className={
                                                                validCount
                                                                    ? "capture-pending-box success"
                                                                    : "capture-pending-box danger"
                                                            }
                                                        >

                                                            <div className="capture-pending-info">
                                                                <i className="pi pi-exclamation-circle"></i>

                                                                <div>
                                                                    <div className="capture-pending-title">
                                                                        Muestras pendientes
                                                                    </div>

                                                                    <div className="capture-pending-text">
                                                                        Pendientes por capturar
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div
                                                                className={
                                                                    validCount
                                                                        ? "capture-pending-count success"
                                                                        : "capture-pending-count danger"
                                                                }
                                                            >
                                                                {countSample}
                                                            </div>

                                                        </div>

                                                    </Col>

                                                    {
                                                        // * ------
                                                    }
                                                </Col>

                                                {/* <div style={{ width: '2px', backgroundColor: '#46afe5 ' }}></div> */}
                                                <Col sm="5" className="p-2 shdow-sm  " style={{
                                                    border: '1px solid #e0e0e0',
                                                    borderRadius: '10px', padding: '12px', fontSize: '12px'
                                                }}>
                                                    <div className="header-capture">

                                                        <div className="header-capture-left">
                                                            <i className="fa fa-list-alt header-capture-icon "></i>

                                                            <span className="header-capture-title">
                                                                Datos Generales
                                                            </span>
                                                        </div>

                                                    </div>

                                                    {historicMode === false ?
                                                        <Col sm="12" className='text-left pt-2' style={{ fontSize: '11px' }}>
                                                            <Row >
                                                                {
                                                                    company && company !== "" &&
                                                                    <Col sm={6} className='p-l-0 p-r-0' >
                                                                        <Col xs={12} sm={12} md={12} lg={12} xl={12} >
                                                                            <div style={{
                                                                                fontWeight: 'bold', color: '#0d3b59', backgroundColor: "#0029400a",
                                                                                padding: '6px', borderRadius: '8px', marginBottom: '10px',
                                                                                textAlign: 'center', fontSize: '12px'
                                                                            }}>
                                                                                <i className='pi pi-building'></i>    Empresa

                                                                            </div>
                                                                            <Col sm="12" className='p-l-0 p-r-0' style={{ textAlign: "center" }} >
                                                                                <b className='pPatient' style={{ color: '#0350a1ff' }}>{company}</b><br />
                                                                            </Col>
                                                                        </Col>
                                                                    </Col>
                                                                }
                                                                {
                                                                    company && company !== "" &&
                                                                    <Col sm={6} className='p-l-0 p-r-0'>
                                                                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                            <div style={{
                                                                                fontWeight: 'bold', color: '#0d3b59', backgroundColor: "#0029400a",
                                                                                padding: '6px', borderRadius: '8px', marginBottom: '10px',
                                                                                textAlign: 'center', fontSize: '12px'
                                                                            }}>
                                                                                <i className='pi pi-file'></i> Convenio
                                                                            </div>
                                                                            <b
                                                                                className='pPatient'
                                                                                style={{
                                                                                    color: '#0350a1ff',
                                                                                    whiteSpace: 'nowrap',
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    display: 'inline-block',
                                                                                    maxWidth: '100%',
                                                                                    width: '100%'
                                                                                }}
                                                                                title={codeAgreement}
                                                                            >
                                                                                <Col sm="12" className='p-l-0 p-r-0' style={{ textAlign: "center" }} >
                                                                                    <label className='' style={{ color: '#0350a1ff' }}>{codeAgreement}</label><br />
                                                                                </Col>
                                                                            </b><br />
                                                                        </Col>
                                                                    </Col>
                                                                }








                                                                <Col xs="6" sm="6" md="6" lg="6" xl="6">
                                                                    {
                                                                        (!listDoctors || listDoctors.length === 0) ? (
                                                                            <div>
                                                                                <i className="icofont icofont-doctor  f-18 iconResults"></i>  <b className='labelPatient'>Médico:  <label className='pPatient'>{"Sin médico asignado"}</label></b> <br />

                                                                            </div>
                                                                        ) : (
                                                                            <div>
                                                                                <i className="icofont icofont-doctor f-18 text-primary"></i>  <b className='labelPatient' >Médico:</b>  <label className='pPatient'>
                                                                                    {listDoctors.map((doctor, index) => (
                                                                                        <span key={index}>{doctor.name}{index < listDoctors.length - 1 ? ', ' : ''}</span>
                                                                                    ))}
                                                                                </label>

                                                                            </div>
                                                                        )
                                                                    }


                                                                </Col>

                                                                <Col xs="6" sm="6" md="6" lg="6" xl="6" className='text-center' >
                                                                    {
                                                                        workMedicalOrder == null || workMedicalOrder == "" ?
                                                                            <label className='txt-danger f-w-700' > <i className='pi pi-exclamation-triangle' ></i> Sin Orden Médica Registrada</label>
                                                                            :

                                                                            <div >
                                                                                <Button block={true} size="xs" onClick={handleCreate} outline color="primary-2x"   >
                                                                                    Ver Orden Médica
                                                                                </Button>
                                                                            </div>
                                                                    }
                                                                </Col>

                                                                <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                                    {
                                                                        observations == "" ?
                                                                            <div>
                                                                                <i className="icofont icofont-warning-alt  f-18 iconResults"></i>  <b className='labelPatient'>Observaciones:</b> <br />
                                                                                <label className='pPatient'>{"Sin observaciones"}</label>
                                                                            </div>
                                                                            :
                                                                            <div>
                                                                                <i className="icofont icofont-warning-alt  f-18 text-danger"></i>  <b className='labelPatient' >Observaciones:</b> <br />
                                                                                <label className='pPatient'>{observations}</label>
                                                                            </div>
                                                                    }
                                                                </Col>

                                                                <br /> <br />
                                                                {/* <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                            {
                                                                commentsFlebo == "" ?
                                                                    <div>
                                                                        <i className="icofont icofont-doctor-alt  f-20 iconResults"></i>  <b className='labelPatient'>Comentarios del flebotomista:</b> <br />
                                                                        <label className='pPatient'>{"Sin observaciones del flebotomista"}</label>
                                                                    </div>
                                                                    :
                                                                    <div>
                                                                        <i className="icofont icofont-doctor-alt  f-20 text-danger"></i>  <b className='labelPatient' >Observaciones del flebotomista:</b> <br />
                                                                        <label className='pPatient txt-danger'>{commentsFlebo}</label>
                                                                    </div>
                                                            }
                                                        </Col> */}
                                                                <br />
                                                                <Col xs="12" sm="12" md="12" lg="12" xl="12" >
                                                                    <i className="fa fa-comment f-18 iconResults"></i><b>Comentarios adjuntos: </b> <br />
                                                                    <InputGroup className='input-group-sm'>
                                                                        <Input type="text" className='form-control form-control-sm input-air-primary' placeholder='Escribe tus comentarios' value={commentsPrintResult} onChange={(e) => handleEditCommentsPrintResults(e)} />
                                                                        <InputGroupAddon addonType='append'>
                                                                            <InputGroupText>
                                                                                <Button className='p-0' color='transparent' size='xs' onClick={saveCommentsWorkOrder}>
                                                                                    <i className='fa fa-save text-danger'></i>
                                                                                </Button>
                                                                            </InputGroupText>
                                                                        </InputGroupAddon>
                                                                    </InputGroup>
                                                                </Col>



                                                            </Row>
                                                        </Col>
                                                        :
                                                        <>
                                                            <h6 className="m-0 text-center">Modo Histórico</h6>
                                                            <CardBody className="p-4 ">
                                                                <Col className="text-left">
                                                                    <label>
                                                                        Esta orden de trabajo se encuentra en modo histórico, lo que significa que no puede ser editada, pero está disponible para su consulta. Si necesita guardar una copia, puede descargarla en el formato que prefiera, ya sea con membrete o sin membrete, según sus necesidades.
                                                                    </label>
                                                                </Col>
                                                                <hr />
                                                                <Row className="align-items-center">
                                                                    {/* Resultado con membrete */}
                                                                    <Col xs="12" sm="6" md="12" lg="12" xl="12" className="d-flex align-items-center mb-3">
                                                                        <img
                                                                            src={require("../../../assets/images/price/resultados.png")}
                                                                            alt="Descargar Resultados"
                                                                            className="img-fluid"
                                                                            style={{ width: "45px", marginRight: "10px" }}
                                                                        />
                                                                        <label>Resultado con membrete</label>
                                                                        <Button
                                                                            size="sm"
                                                                            onClick={() => printHistoricPdf(pdf_historic)}
                                                                            outline
                                                                            color="success"
                                                                            className="ml-3"
                                                                        >
                                                                            Descargar
                                                                        </Button>
                                                                    </Col>

                                                                    {/* Resultado sin membrete */}
                                                                    <Col xs="12" sm="6" md="12" lg="12" xl="12" className="d-flex align-items-center mb-3">
                                                                        <img
                                                                            src={require("../../../assets/images/price/resultados.png")}
                                                                            alt="Descargar Resultados"
                                                                            className="img-fluid"
                                                                            style={{ width: "45px", marginRight: "10px" }}
                                                                        />
                                                                        <label>Resultado sin membrete</label>
                                                                        <Button
                                                                            size="sm"
                                                                            onClick={() => printHistoricPdf(pdf_without_letter)}
                                                                            outline
                                                                            color="primary"
                                                                            className="ml-4"
                                                                        >
                                                                            Descargar
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>

                                                        </>


                                                    }
                                                </Col>

                                                {/* <div style={{ width: '2px', backgroundColor: '#46afe5' }}></div> */}
                                                <Col sm="3" className="p-2">
                                                    <div className="header-capture">

                                                        <div className="header-capture-left">
                                                            <i className="fa fa-cogs header-capture-icon"></i>

                                                            <span className="header-capture-title">
                                                                Acciones
                                                            </span>
                                                        </div>

                                                    </div>

                                                    {historicMode === false ?
                                                        <>
                                                            <div className='pt-2' style={{ display: 'flex', justifyContent: 'center' }}>
                                                                <ButtonGroup vertical>
                                                                    {
                                                                        credit_payment == "True" ?

                                                                            printAvailable && paid ?
                                                                                resultsPartial ? <>
                                                                                    {
                                                                                        dobleValidacion ? <>

                                                                                            {
                                                                                                // listDoctors.length && sendDoctor > 0 ? <>

                                                                                                //     <UncontrolledDropdown color='danger' className='p-0 m-0'>
                                                                                                //         <DropdownToggle size='sm' block outline color='danger'>
                                                                                                //             &nbsp; Enviar Resultados  &nbsp;
                                                                                                //         </DropdownToggle>
                                                                                                //         <DropdownMenu >
                                                                                                //             <DropdownItem header>Selecciona una opción</DropdownItem>
                                                                                                //             <DropdownItem onClick={() => sendResultForEmail(false)}>{"Enviar al Paciente"}</DropdownItem>
                                                                                                //             <DropdownItem onClick={() => sendResultForEmail(true)}>{"Enviar al Doctor"}</DropdownItem>
                                                                                                //         </DropdownMenu>
                                                                                                //     </UncontrolledDropdown>

                                                                                                // </> : <>
                                                                                                <Button block={true} size="sm" onClick={() => handleListExamEmail(workOrderId)} outline color="danger">
                                                                                                    Entregar Resultados
                                                                                                </Button>
                                                                                                // </>
                                                                                            }



                                                                                            {/* <Button block={true} size="sm" onClick={() => printWorkOrder(true)} outline color="primary">
                                                                                        Imprimir resultados
                                                                                    </Button> */}

                                                                                            {/* <Button block={true} size="sm" onClick={() => handleListPrint(workOrderId)} outline color="info">
                                                                                            Imprimir resultados
                                                                                        </Button> */}
                                                                                        </>
                                                                                            : ""
                                                                                    }

                                                                                    {/* <Button block={true} size="sm" onClick={() => getViewPreview(false)} outline color="primary">
                                                                                    Previsualizar
                                                                                </Button> */}
                                                                                    {

                                                                                        (_url === cedimi || _url === semlab) && microBinnacleCedimi === true && (
                                                                                            <Button block={true} size="sm" onClick={() => printBitacoraMedica(workOrderId)} outline color='danger' disabled={loadingButton} className={loadingButton ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                                                                                                Bitácora Microbiología
                                                                                            </Button>
                                                                                        )
                                                                                    }
                                                                                    <Button block={true} size="sm" onClick={saveAllAnalytes} outline color='info' disabled={loadingButton} className={loadingButton ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                                                                                        Guardar resultados
                                                                                    </Button>


                                                                                </>
                                                                                    :

                                                                                    dobleValidacion ? <>
                                                                                        {
                                                                                            // listDoctors.length && sendDoctor ? <>
                                                                                            //     <UncontrolledDropdown color='danger' className='p-0 m-0'>
                                                                                            //         <DropdownToggle size='sm' block outline color='danger'>
                                                                                            //             &nbsp; Enviar Resultados  &nbsp;
                                                                                            //         </DropdownToggle>
                                                                                            //         <DropdownMenu >
                                                                                            //             <DropdownItem header>Selecciona una opción</DropdownItem>
                                                                                            //             <DropdownItem onClick={() => sendResultForEmail(false)}>{"Enviar al Paciente"}</DropdownItem>
                                                                                            //             <DropdownItem onClick={() => sendResultForEmail(true)}>{"Enviar al Doctor"}</DropdownItem>
                                                                                            //         </DropdownMenu>
                                                                                            //     </UncontrolledDropdown>
                                                                                            // </> : <>
                                                                                            //     <Button block={true} size="sm" onClick={() => sendResultForEmail(false)} outline color="primary">
                                                                                            //         Enviar resultados
                                                                                            //     </Button>
                                                                                            // </>
                                                                                            <Button block={true} size="sm" onClick={() => handleListExamEmail(workOrderId)} outline color="primary">
                                                                                                Entregar Resultados
                                                                                            </Button>
                                                                                        }
                                                                                        {/* <Button block={true} size="sm" onClick={() => printWorkOrder(true)} outline color="primary">
                                                                                    Imprimir resultados
                                                                                </Button> */}

                                                                                        {/* <Button block={true} size="sm" onClick={() => handleListPrint(workOrderId)} outline color="info">
                                                                                        Imprimir resultados
                                                                                    </Button> */}
                                                                                    </> : ""
                                                                                :
                                                                                <>
                                                                                    {
                                                                                        (_url === cedimi || _url === semlab) && microBinnacleCedimi === true && (
                                                                                            <Button block={true} size="sm" onClick={() => printBitacoraMedica(workOrderId)} outline color='danger' disabled={loadingButton} className={loadingButton ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                                                                                                Bitácora Microbiología
                                                                                            </Button>
                                                                                        )
                                                                                    }
                                                                                    <Button block={true} size="sm" onClick={saveAllAnalytes} outline color='info' disabled={loadingButton} className={loadingButton ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                                                                                        Guardar resultados &nbsp;
                                                                                    </Button>

                                                                                </>
                                                                            : printAvailable ?
                                                                                resultsPartial ? <>
                                                                                    {
                                                                                        dobleValidacion ? <>

                                                                                            {/* {
                                                                                            listDoctors.length && sendDoctor > 0 ? <>

                                                                                                <UncontrolledDropdown color='danger' className='p-0 m-0'>
                                                                                                    <DropdownToggle size='sm' block outline color='danger'>
                                                                                                        &nbsp; Enviar Resultados  &nbsp;
                                                                                                    </DropdownToggle>
                                                                                                    <DropdownMenu >
                                                                                                        <DropdownItem header>Selecciona una opción</DropdownItem>
                                                                                                        <DropdownItem onClick={() => sendResultForEmail(false)}>{"Enviar al Paciente"}</DropdownItem>
                                                                                                        <DropdownItem onClick={() => sendResultForEmail(true)}>{"Enviar al Doctor"}</DropdownItem>
                                                                                                    </DropdownMenu>
                                                                                                </UncontrolledDropdown>

                                                                                            </> : <>
                                                                                                <Button block={true} size="sm" onClick={() => sendResultForEmail(false)} outline color="danger">
                                                                                                    Enviar resultados
                                                                                                </Button>
                                                                                            </>
                                                                                        } */}
                                                                                            <Button block={true} size="sm" onClick={() => handleListExamEmail(workOrderId)} outline color="primary">
                                                                                                Entregar Resultados
                                                                                            </Button>
                                                                                            {/*
                                                                                    <Button block={true} size="sm" onClick={() => printWorkOrder(true)} outline color="primary">
                                                                                        Imprimir resultados
                                                                                    </Button> */}

                                                                                            {/* <Button block={true} size="sm" onClick={() => handleListPrint(workOrderId)} outline color="info">
                                                                                            Imprimir resultados
                                                                                        </Button> */}
                                                                                        </>
                                                                                            : ""
                                                                                    }
                                                                                    {/* <Button block={true} size="sm" onClick={() => getViewPreview(false)} outline color="primary">
                                                                                    Previsualizar
                                                                                </Button> */}
                                                                                    {
                                                                                        (_url === cedimi || _url === semlab) && microBinnacleCedimi === true && (
                                                                                            <Button block={true} size="sm" onClick={() => printBitacoraMedica(workOrderId)} outline color='danger' disabled={loadingButton} className={loadingButton ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                                                                                                Bitácora Microbiología
                                                                                            </Button>
                                                                                        )
                                                                                    }
                                                                                    <Button block={true} size="sm" onClick={saveAllAnalytes} outline color='info' disabled={loadingButton} className={loadingButton ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                                                                                        Guardar resultados
                                                                                    </Button>

                                                                                </>
                                                                                    :

                                                                                    dobleValidacion ? <>
                                                                                        {/* {
                                                                                        listDoctors.length && sendDoctor ? <>
                                                                                            <UncontrolledDropdown color='danger' className='p-0 m-0'>
                                                                                                <DropdownToggle size='sm' block outline color='danger'>
                                                                                                    &nbsp; Enviar Resultados &nbsp;
                                                                                                </DropdownToggle>
                                                                                                <DropdownMenu >
                                                                                                    <DropdownItem header>Selecciona una opción</DropdownItem>
                                                                                                    <DropdownItem onClick={() => sendResultForEmail(false)}>{"Enviar al Paciente"}</DropdownItem>
                                                                                                    <DropdownItem onClick={() => sendResultForEmail(true)}>{"Enviar al Doctor"}</DropdownItem>
                                                                                                </DropdownMenu>
                                                                                            </UncontrolledDropdown>
                                                                                        </> : <>
                                                                                            <Button block={true} size="sm" onClick={() => sendResultForEmail(false)} outline color="primary">
                                                                                                Enviar resultados
                                                                                            </Button>
                                                                                        </>
                                                                                    } */}
                                                                                        <Button block={true} size="sm" onClick={() => handleListExamEmail(workOrderId)} outline color="primary">
                                                                                            Entregar Resultados
                                                                                        </Button>
                                                                                        {/* <Button block={true} size="sm" onClick={() => printWorkOrder(true)} outline color="primary">
                                                                                    Imprimir resultados
                                                                                </Button> */}

                                                                                        {/* <Button block={true} size="sm" onClick={() => handleListPrint(workOrderId)} outline color="info">
                                                                                        Imprimir resultados
                                                                                    </Button> */}
                                                                                    </> : ""
                                                                                :
                                                                                <>
                                                                                    {
                                                                                        (_url === cedimi || _url === semlab) && microBinnacleCedimi === true && (
                                                                                            <Button block={true} size="sm" onClick={() => printBitacoraMedica(workOrderId)} outline color='danger' disabled={loadingButton} className={loadingButton ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                                                                                                Bitácora Microbiología
                                                                                            </Button>
                                                                                        )
                                                                                    }

                                                                                    <Button block={true} size="sm" onClick={saveAllAnalytes} outline color='info' disabled={loadingButton} className={loadingButton ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                                                                                        Guardar resultados &nbsp;
                                                                                    </Button>


                                                                                </>



                                                                    }

                                                                    {canPreview && (
                                                                        <Button block size="sm" onClick={() => getViewPreview(true)} outline color="primary">
                                                                            Previsualizar
                                                                        </Button>
                                                                    )}
                                                                    {allValidated && (
                                                                        <Button
                                                                            block
                                                                            size="sm"
                                                                            onClick={() => openDialogRelease()}
                                                                            outline
                                                                            color='success'
                                                                        >
                                                                            Liberar todo
                                                                        </Button>
                                                                    )}

                                                                </ButtonGroup>
                                                                {/* <Col xs="2" sm="2" md="2" lg="2" xl="2">
                                                        </Col> */}
                                                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '0.5rem' }}>
                                                                    {paid === false ? (
                                                                        <Label className="f-w-600 f-12 badge badge-light-danger">Con adeudo</Label>
                                                                    ) : null}
                                                                </div>

                                                                {/* <Col sm="12" style={{ textAlign: "-webkit-center" }} > <br />
                                                            <Button color="light" className=" btn-air-light m-1" onClick={() => window.location.href = `/busqueda/trabajo-dia`}><i className="icofont icofont-arrow-left"></i> {ButtonGoBack}</Button>
                                                        </Col> */}

                                                            </div>


                                                        </>



                                                        :
                                                        null
                                                    }
                                                </Col>

                                            </Row>



                                        </Card>

                                        {
                                            showStickyPatient && (

                                                <div
                                                    className={`stickyPatientContainer
                                                    ${isSidebarOpen ? "stickySidebarOpen" : "stickySidebarClose"}
                                                    ${_url === cedimi && !isHorizontalMenu ? "stickyMenuHorizontal" : ""}

                                                `}
                                                >

                                                    <div className="stickyPatientContent">
                                                        {/* <div
                                                    className={`stickyPatientContent ${
                                                        patient.name_gender === "FEMENINO"
                                                            ? "stickyPatientContentFemale"
                                                            : "stickyPatientContentMale"
                                                    }`}
                                                > */}

                                                        <div className="stickyPatientMain">

                                                            <div
                                                                className={`stickyPatientAvatar ${patient.name_gender === "FEMENINO"
                                                                    ? "stickyPatientAvatarFemale"
                                                                    : "stickyPatientAvatarMale"
                                                                    }`}
                                                            >
                                                                <i className="fa fa-user"></i>
                                                            </div>

                                                            <div className="stickyPatientData">

                                                                <div className="stickyPatientItem">

                                                                    <span className="stickyPatientLabel">
                                                                        NIM
                                                                    </span>

                                                                    <span className="stickyPatientNim">
                                                                        {nimPatient}
                                                                    </span>

                                                                </div>

                                                                <div className="stickyPatientItem">

                                                                    <span className="stickyPatientLabel">
                                                                        Paciente
                                                                    </span>

                                                                    <span className="stickyPatientValue stickyPatientName">
                                                                        {patient.name}{" "}
                                                                        {patient.paternal_surname}{" "}
                                                                        {patient.maternal_surname}
                                                                    </span>

                                                                </div>

                                                                <div className="stickyPatientItem">

                                                                    <span className="stickyPatientLabel">
                                                                        Sexo
                                                                    </span>

                                                                    <span className="stickyPatientValue">
                                                                        {patient.name_gender}
                                                                    </span>

                                                                </div>

                                                                <div className="stickyPatientItem">

                                                                    <span className="stickyPatientLabel">
                                                                        Edad
                                                                    </span>

                                                                    <span className="stickyPatientValue">
                                                                        {
                                                                            patient.age > 0
                                                                                ? patient.age + " año(s)"
                                                                                : patient.format_age
                                                                        }
                                                                    </span>

                                                                </div>

                                                                <div className="stickyPatientItem">

                                                                    <span className="stickyPatientLabel">
                                                                        Fecha nacimiento
                                                                    </span>

                                                                    <span className="stickyPatientValue">
                                                                        {patient.birthday}
                                                                    </span>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div className="stickyPatientToolbar">
                                                            {
                                                                loadingPatient === true ?
                                                                    <>

                                                                        <div className="stickyPatientToolbar">

                                                                            <div className="stickyGroup">

                                                                                <button
                                                                                    className="stickyIconBtn stickyNavBtn"
                                                                                    onClick={() => executeScroll()}
                                                                                    title="Ir arriba"
                                                                                >
                                                                                    <i className="fa fa-arrow-up fa-lg"></i>
                                                                                </button>

                                                                                <button
                                                                                    className={`stickyIconBtn stickyNavBtn ${loadingButton || nextNim == null
                                                                                        ? "stickyDisabled"
                                                                                        : ""
                                                                                        }`}
                                                                                    onClick={() =>
                                                                                        !loadingButton &&
                                                                                        nextNim != null &&
                                                                                        gotoNim(nextNim)
                                                                                    }
                                                                                    title="Anterior"
                                                                                >
                                                                                    <i className="fa fa-angle-left fa-lg"></i>
                                                                                </button>

                                                                                <button
                                                                                    className={`stickyIconBtn stickyNavBtn ${loadingButton || backNim == null
                                                                                        ? "stickyDisabled"
                                                                                        : ""
                                                                                        }`}
                                                                                    onClick={() =>
                                                                                        !loadingButton &&
                                                                                        backNim != null &&
                                                                                        gotoNim(backNim)
                                                                                    }
                                                                                    title="Siguiente"
                                                                                >
                                                                                    <i className="fa fa-angle-right fa-lg"></i>
                                                                                </button>

                                                                                <button
                                                                                    className="stickyIconBtn stickyBackBtn"
                                                                                    onClick={() =>
                                                                                        window.location.href =
                                                                                        `/busqueda/trabajo-dia`
                                                                                    }
                                                                                    title="Regresar"
                                                                                >
                                                                                    <i className="fa fa-reply fa-lg"></i>
                                                                                </button>

                                                                            </div>

                                                                            <div className="stickyGroup">
                                                                                {
                                                                                    enable_tracking_toma &&
                                                                                    <button
                                                                                        type="button"
                                                                                        className="stickyIconBtn stickyClinicalBtn"
                                                                                        onClick={() => setVisibleTop(true)}
                                                                                        title="Información clínica"
                                                                                        style={{
                                                                                            position: "relative",
                                                                                            zIndex: 99999,
                                                                                            pointerEvents: loadingButton ? "none" : "auto"
                                                                                        }}
                                                                                    >
                                                                                        <i className="fa fa-stethoscope fa-lg"></i>
                                                                                    </button>
                                                                                }


                                                                            </div>

                                                                            <div className="stickyGroup">

                                                                                <button
                                                                                    type="button"
                                                                                    className={`stickyIconBtn stickySaveBtn ${loadingButton ? "stickyDisabled" : ""
                                                                                        }`}
                                                                                    style={{
                                                                                        position: "relative",
                                                                                        zIndex: 99999,
                                                                                        pointerEvents: loadingButton ? "none" : "auto"
                                                                                    }}
                                                                                    onClick={saveAllAnalytes}
                                                                                    title="Guardar"
                                                                                >
                                                                                    {
                                                                                        loadingButton
                                                                                            ? <i className="fa fa-spinner fa-spin fa-lg"></i>
                                                                                            : <i className="fa fa-floppy-o fa-lg"></i>
                                                                                    }
                                                                                </button>



                                                                                <button
                                                                                    className="stickyIconBtn stickyPreviewBtn"
                                                                                    onClick={() => getViewPreview(true)}
                                                                                    title="Vista previa"
                                                                                    style={{
                                                                                        position: "relative",
                                                                                        zIndex: 99999,
                                                                                        pointerEvents: loadingButton ? "none" : "auto"
                                                                                    }}
                                                                                >
                                                                                    <i className="icofont icofont-document-search fa-lg"></i>
                                                                                </button>


                                                                            </div>



                                                                        </div>

                                                                    </>
                                                                    : ""

                                                            }



                                                        </div>

                                                    </div>

                                                </div>
                                            )
                                        }

                                    </>

                                ) : (
                                    <Col sm="12" md="12" lg="12" xl="12" className='p-l-0 p-r-0' >
                                        <br /><br />
                                        <div style={{ textAlign: "-webkit-center" }}>
                                            <img className='img-fluid' src={require("../../../assets/images/loginHelenLabs/Alerts/Alert.svg")} style={{ width: "35%" }} alt="" />
                                            <br />
                                            <p className='f-18'>{"No hay ningún resultado con ese Nim"}</p>
                                        </div>
                                    </Col>

                                )
                            )
                        }
                    </Col>
                    {
                        // ? CONFIGURATION QUESTION
                    }

                    <Row >
                        {historicMode === false ?
                            sections.length > 0 &&
                            sections.map((seccion, key) => {
                                return <Col sm="12" key={key}>
                                    <CardHeader className="b-l-primary pb-2 pt-2 fondo">
                                        <label className='Label-input'>{seccion.name}-{txtsection}</label>
                                    </CardHeader>
                                    <CardBody className='p-l-0 p-r-0' >
                                        {
                                            seccion.exams.map((examen, key2) => {


                                                return <ViewExam key={key2}
                                                    // ! GLOBALES
                                                    is_profile={false}
                                                    typeArray="section"
                                                    sectionProfileId={seccion.id}

                                                    // ! PATIENT
                                                    age={patient.age}
                                                    days_age={patient.days_age}
                                                    gender={patient.id_gender}
                                                    idPat={patient.id_patient}
                                                    namePatiente={patient.name + patient.paternal_surname + patient.maternal_surname}
                                                    nameP={patient.name}
                                                    surnameP={patient.paternal_surname}
                                                    surnameM={patient.maternal_surname}

                                                    // ! ANALYTE
                                                    releaseExam={releaseExam}
                                                    examen={examen}
                                                    saveIndividualAnalyte={saveIndividualAnalyte}
                                                    validateAnalyte={validateAnalyte}
                                                    validateExam={validateExam}
                                                    analytes={analytes}
                                                    previewWorkOrder={previewWorkOrder}
                                                    saveFileExamImagenology={saveIndividualExamImagenology}
                                                    handleGetDocumentImagenology={handleGetDocumentImagenology}
                                                    removeValidationFromExamOrProfile={removeValidationFromExamOrProfile}
                                                    updateMethod={updateMethod}
                                                    setAnalytes={setAnalytes}

                                                    // ? PRESUMTIVE RESULTS
                                                    addPresumptiveResult={addPresumptiveResult}
                                                    presumptive={presumptive}
                                                    setPresumptive={setPresumptive}
                                                    removePresumptiveResult={removePresumptiveResult}
                                                    PrintingPresumptiveResult={PrintingPresumptiveResult}
                                                    handleChangePresumptive={handleChangePresumptive}
                                                    cancelRemovePresumtiveResults={cancelRemovePresumtiveResults}
                                                    printingGlobal={printingGlobal}
                                                    cancelPrintingPresumptive={cancelPrintingPresumptive}
                                                    removePrintingGlobal={removePrintingGlobal}
                                                    valdatePresumtiveResults={valdatePresumtiveResults}
                                                    ReleasePresumtiveResults={ReleasePresumtiveResults}
                                                    unvalidatePresumtiveResults={unvalidatePresumtiveResults}
                                                    unreleasePresumtiveResults={unreleasePresumtiveResults}

                                                    // ? BACTERIUM
                                                    addMicroAislado={addMicroAislado}
                                                    microBacteriums={microBacteriums}
                                                    setMicroBacteriums={setMicroBacteriums}
                                                    microAntibiograms={microAntibiograms}
                                                    microAntibiotics={microAntibiotics}
                                                    setMicroAntibiotics={setMicroAntibiotics}
                                                    handleTypeBacterium={handleTypeBacterium}
                                                    handleChangeComments={handleChangeComments}
                                                    removeBacterium1={removeBacterium1}
                                                    removeBacteriumAntibitic={removeBacteriumAntibitic}
                                                    ValidateBacterium={ValidateBacterium}
                                                    UnValidateBacterium={UnValidateBacterium}
                                                    ReleaseBacterium={ReleaseBacterium}
                                                    UnReleaseBacterium={UnReleaseBacterium}
                                                    setValidMicro={setValidMicro}
                                                    handleFullUnvalidate={handleFullUnvalidate}
                                                    microComments={microComments}
                                                    handleChangeIsolated={handleChangeIsolated}
                                                    addCommentGlobal={addCommentGlobal}
                                                    handleChangeResult={handleChangeResult}
                                                    handleTypeResult={handleTypeResult}
                                                    toggleTableGlobalComment={toggleTableGlobalComment}
                                                    modalTableGlobalComment={modalTableGlobalComment}
                                                    method={method}
                                                    handleCreateGlobalComment={handleCreateGlobalComment}
                                                    modalCrudComment={modalCrudComment}
                                                    toggleCrudComment={toggleCrudComment}
                                                    saveCreate={saveCreate}
                                                    handleInputChange={handleInputChange}
                                                    text={text}
                                                    type={type}
                                                    comments={comments}
                                                    handleInsert={handleInsert}
                                                    handleDeleteCommentText={handleDeleteCommentText}
                                                    loading={loading}
                                                    search={search}
                                                    setSearch={setSearch}
                                                    handleRefresh={handleRefresh}
                                                    keyComments={keyComments}

                                                    // ? CURVES
                                                    listCurves={listCurves}
                                                    handleChangeCurveResult={handleChangeCurveResult}
                                                    handleChangeCurveTime={handleChangeCurveTime}
                                                    disabledInputFollowUp={disabledInputFollowUp}
                                                    handleResetResultCurves={handleResetResultCurves}
                                                    loadingValidate={loadingValidate}
                                                    loadingReleaseExam={loadingReleaseExam}
                                                    loadingRemove={loadingRemove}
                                                    changeMethodCurves={changeMethodCurves}
                                                    // setAppCodeOrMethodExam={setAppCodeOrMethodExam}
                                                    appCodeOrMethodExam={appCodeOrMethodExam}
                                                    fetchExamMethodData={fetchExamMethodData}
                                                    setListCurves={setListCurves}
                                                    disableMethodInput={disableMethodInput}
                                                    setAppCodeOrMethodExam={setAppCodeOrMethodExam}

                                                    loadingValidateCapture={loadingValidateCapture}
                                                    loadingReleaseExamCapture={loadingReleaseExamCapture}
                                                    loadingRemoveCapture={loadingRemoveCapture}

                                                    idWChart={idWChart}
                                                    enable_tracking_tomas={enable_tracking_toma}
                                                    pyrsaClient={_url === pyrsa ? true : false}
                                                    getResultsHistory={getResultsHistory}

                                                    // ? PATIENT HISTORIAL
                                                    selectedExam={selectedExam}
                                                    visibleSidebar={visibleSidebar}
                                                    historicoRaw={historicoRaw}
                                                    historicoData={historicoData}
                                                    setSelectedExam={setSelectedExam}
                                                    setVisibleSidebar={setVisibleSidebar}
                                                    setHistoricoRaw={setHistoricoRaw}
                                                    setHistoricoData={setHistoricoData}
                                                    handleHistorico={handleHistorico}
                                                    getUltimos3Nims={getUltimos3Nims}
                                                    buildHistorico3={buildHistorico3}
                                                    loadingHistorico={loadingHistorico}
                                                    getNimsData={getNimsData}
                                                    hasHistorico={hasHistorico}
                                                    historicoGlobal={historicoGlobal}
                                                    showResistanceView={showResistanceView}
                                                    setShowResistanceView={setShowResistanceView}
                                                    _capture_lock={_capture_lock}


                                                />
                                            })
                                        }
                                    </CardBody>
                                </Col>
                            })
                            :
                            null
                        }
                        {historicMode === false ?
                            profiles.length > 0 &&
                            profiles.map((perfil, key) => {
                                return <Col sm="12" key={`perfil ` + key}>
                                    {
                                        perfil.exams.length > 0 ? <>
                                            <CardHeader className="b-l-primary pb-2 pt-2 fondo">
                                                <label className='Label-input'>{perfil.name} / Perfil</label>
                                                <div className='float-right'>
                                                    {
                                                        perfil.readyToValidateProfile === true ?
                                                            (perfil.readyToReleaseProfile === true ? "" : <ButtonValidate validateProfile={validateProfile} ready={true} id_profile={perfil.id_profile} id_work_order={perfil.id_work_order} id_work_order_profile={perfil.id_work_order_profile} loadingValidateProfileC={loadingValidateProfileC} />)
                                                            : <>
                                                                <ButtonValidate ready={false} />
                                                            </>
                                                    }

                                                </div>
                                            </CardHeader>
                                            <CardBody className='p-l-0 p-r-0' >
                                                {
                                                    perfil.exams.map((examen, key2) => {

                                                        return <ViewExam key={key2}
                                                            // !GLOBALES
                                                            typeArray="profile"
                                                            sectionProfileId={perfil.id_profile}
                                                            is_profile={true}

                                                            // ! PATIENT
                                                            age={patient.age}
                                                            days_age={patient.days_age}
                                                            gender={patient.id_gender}
                                                            idPat={patient.id_patient}
                                                            namePatiente={patient.name + patient.paternal_surname + patient.maternal_surname}
                                                            nameP={patient.name}
                                                            surnameP={patient.paternal_surname}
                                                            surnameM={patient.maternal_surname}

                                                            // ! ANALYTE
                                                            releaseExam={releaseExam}
                                                            examen={examen}
                                                            saveIndividualAnalyte={saveIndividualAnalyte}
                                                            validateAnalyte={validateAnalyte}
                                                            validateExam={validateExam}
                                                            analytes={analytes}
                                                            curves={perfil.curves !== null ? perfil.curves : null}
                                                            saveFileExamImagenology={saveIndividualExamImagenology}
                                                            handleGetDocumentImagenology={handleGetDocumentImagenology}
                                                            removeValidationFromExamOrProfile={removeValidationFromExamOrProfile}
                                                            updateMethod={updateMethod}
                                                            setAnalytes={setAnalytes}

                                                            // ? PRESUMTIVE RESULTS
                                                            addPresumptiveResult={addPresumptiveResult}
                                                            presumptive={presumptive}
                                                            setPresumptive={setPresumptive}
                                                            removePresumptiveResult={removePresumptiveResult}
                                                            PrintingPresumptiveResult={PrintingPresumptiveResult}
                                                            handleChangePresumptive={handleChangePresumptive}
                                                            cancelRemovePresumtiveResults={cancelRemovePresumtiveResults}
                                                            printingGlobal={printingGlobal}
                                                            cancelPrintingPresumptive={cancelPrintingPresumptive}
                                                            removePrintingGlobal={removePrintingGlobal}
                                                            valdatePresumtiveResults={valdatePresumtiveResults}
                                                            ReleasePresumtiveResults={ReleasePresumtiveResults}
                                                            unvalidatePresumtiveResults={unvalidatePresumtiveResults}
                                                            unreleasePresumtiveResults={unreleasePresumtiveResults}

                                                            // ? BACTERIUM
                                                            addMicroAislado={addMicroAislado}
                                                            microBacteriums={microBacteriums}
                                                            setMicroBacteriums={setMicroBacteriums}
                                                            microAntibiograms={microAntibiograms}
                                                            microAntibiotics={microAntibiotics}
                                                            setMicroAntibiotics={setMicroAntibiotics}
                                                            handleTypeBacterium={handleTypeBacterium}
                                                            handleChangeComments={handleChangeComments}
                                                            removeBacterium1={removeBacterium1}
                                                            removeBacteriumAntibitic={removeBacteriumAntibitic}
                                                            ValidateBacterium={ValidateBacterium}
                                                            UnValidateBacterium={UnValidateBacterium}
                                                            ReleaseBacterium={ReleaseBacterium}
                                                            UnReleaseBacterium={UnReleaseBacterium}
                                                            handleFullUnvalidate={handleFullUnvalidate}
                                                            setValidMicro={setValidMicro}
                                                            handleChangeIsolated={handleChangeIsolated}
                                                            microComments={microComments}
                                                            addCommentGlobal={addCommentGlobal}
                                                            handleChangeResult={handleChangeResult}
                                                            handleTypeResult={handleTypeResult}
                                                            toggleTableGlobalComment={modalTableGlobalComment}
                                                            modalTableGlobalComment={modalTableGlobalComment}
                                                            method={method}
                                                            handleCreateGlobalComment={handleCreateGlobalComment}
                                                            toggleCrudComment={toggleCrudComment}
                                                            modalCrudComment={modalCrudComment}
                                                            saveCreate={saveCreate}
                                                            handleInputChange={handleInputChange}
                                                            text={text}
                                                            type={type}
                                                            comments={comments}
                                                            handleInsert={handleInsert}
                                                            handleDeleteCommentText={handleDeleteCommentText}
                                                            loading={loading}
                                                            search={search}
                                                            setSearch={setSearch}
                                                            handleRefresh={handleRefresh}
                                                            keyComments={keyComments}
                                                            loadingValidate={loadingValidate}
                                                            loadingReleaseExam={loadingReleaseExam}
                                                            loadingRemove={loadingRemove}
                                                            changeMethodCurves={changeMethodCurves}
                                                            // setAppCodeOrMethodExam={setAppCodeOrMethodExam}
                                                            appCodeOrMethodExam={appCodeOrMethodExam}
                                                            fetchExamMethodData={fetchExamMethodData}
                                                            setListCurves={setListCurves}
                                                            disableMethodInput={disableMethodInput}
                                                            setAppCodeOrMethodExam={setAppCodeOrMethodExam}

                                                            loadingValidateCapture={loadingValidateCapture}
                                                            loadingReleaseExamCapture={loadingReleaseExamCapture}
                                                            loadingRemoveCapture={loadingRemoveCapture}

                                                            idWChart={idWChart}
                                                            enable_tracking_tomas={enable_tracking_toma}
                                                            pyrsaClient={_url === pyrsa ? true : false}
                                                            
                                                            //? PATIENT HISTORIAL
                                                            getResultsHistory={getResultsHistory}
                                                            selectedExam={selectedExam}
                                                            visibleSidebar={visibleSidebar}
                                                            historicoRaw={historicoRaw}
                                                            historicoData={historicoData}
                                                            setSelectedExam={setSelectedExam}
                                                            setVisibleSidebar={setVisibleSidebar}
                                                            setHistoricoRaw={setHistoricoRaw}
                                                            setHistoricoData={setHistoricoData}
                                                            handleHistorico={handleHistorico}
                                                            getUltimos3Nims={getUltimos3Nims}
                                                            buildHistorico3={buildHistorico3}
                                                            loadingHistorico={loadingHistorico}
                                                            getNimsData={getNimsData}
                                                            hasHistorico={hasHistorico}
                                                            historicoGlobal={historicoGlobal}
                                                            showResistanceView={showResistanceView}
                                                            setShowResistanceView={setShowResistanceView}

                                                            _capture_lock={_capture_lock}
                                                        />
                                                    })
                                                }
                                            </CardBody>
                                        </>
                                            : ""
                                    }
                                </Col >
                            })
                            : null
                        }

                    </Row >
                </div >

            </Container >
            <ModalViewMedicalOrder
                {
                ...{
                    modal, modalTitle1, workMedicalOrder, loading, method, toggle, typeModal, type_file,
                    typeModalMedical, toggleMedical, modalMedical
                }
                }
            />
            <ModalPreViewMedicalOrder
                {
                ...{
                    modal, workMedicalOrderPDF, workMedicalOrderPDFDownload,
                    loading, method, closeDialog, typeModal, type_file, workMedicalOrderPDFLoading, loadingPdf
                }
                }
            />
            <ModalConfirmReleaseAll
                {...{
                    modalRelease, closeDialogRelease, loadingRelease, releaseAll
                }}
            />
            <ModalViewDocImagenology
                {
                ...{
                    modalViewImagenology, modalTitleImg, toggleModalViewImagenology, documentImagenology
                }
                }
            />

            <ModalPrintI
                {
                ...{
                    togglePrintI, typeModalPrintI, modalPrintI, dataExams, handleCheckProfile, handleCheckAll, Impresionbyexam, id_workorder_print, handleCheckAllProfile, handleInputChange, letter, loading
                }
                }
            />

            <ModalTableGlobalComment
                {
                ...{
                    toggleTableGlobalComment, modalTableGlobalComment, method, handleCreateGlobalComment, modalCrudComment, toggleCrudComment, saveCreate, handleInputChange, text, type,
                    comments, handleInsert, handleDeleteCommentText, loading, search, setSearch, keyComments, modalAlert, showDeleteAlert, loadingExport, handleClear, handleSearch,

                    saveDeleteComment, closeDeleteAlertText, openDeleteAlertText, setIdDelete, handleExportExcelComment,
                    searchComment, closeDialogComments
                }
                }
            />

            <SidebarClinicalInfo
                {
                ...{
                    uniqueQuestions, tableRows, visibleTop, setVisibleTop

                }
                }

            />

            <ModalExamsEmail
                {...{
                    toggleListExamEmail,
                    modalExamsEmail,
                    dataExams,
                    handleCheckProfile,
                    handleCheckAll,
                    handleCheckAllProfile,
                    handleFindExam,
                    // respuestaAPI,
                    sendResultEmail,
                    sendConfig,
                    handleSendEmail,
                    sending,
                    setStep, setAuditPanel, auditPanel, markAllActive, handleMarkAllClick, step,
                    isSelectable, statusMap, toggleAuditPanel, toggleProfile, openProfiles, selectedCount, resetModalExamEmail,
                    getFullAuditHistory, handleInputChange, letter,
                    getStatus, _url_helen
                }}
            />





        </Fragment >
    )
}
